export { default } from "./Custom404";
